// This module exports a function to fetch parties data from the backend API
// Endpoint: GET /auth/addparty

import axios from 'axios';

const fetchParties = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/auth/addparty`
    );
    return response.data; 
    console.log("fetchParties ",response.data);
    
    // Array of party objects from the database
  } catch (error) {
    console.error('Error fetching parties:', error);
    return [];
  }
};

// For compatibility with original export
const parties = fetchParties;

export default parties;

